export const GPS_BEARER = 'GpsBearer';
export const GPS_LOCALE = 'GpsLocale';
